export default __webpack_public_path__ + "assets/Citizens-e24bcb3ca4d25158cdc189aa3e248e80.svg";